import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Catalogue } from '@shared/services/catalogue/models';

@Injectable({ providedIn: 'root' })
export class CatalogueService extends ApiServiceBase<Catalogue> {
  constructor() {
    super('catalogue', 'catalogue', 'fournierWebservice');
  }
}
